// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { screenMdMin, spacer16, heading1FontSizeXSmall, spacer4, spacer8, IconArrowRight, Type } from '@spotify-internal/encore-web';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { ButtonTertiaryAsLink, DELAYS, fadeInAnimation, ImageAspectBox1x1, withAnimationContext } from '../../ui';
import { fixHref } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Segment = styled.div.withConfig({
  displayName: "ThreeUpSegment__Segment",
  componentId: "cmlk1j-0"
})(["display:flex;flex-direction:column;text-align:center;"]);
var ImageBox = styled(ImageAspectBox1x1).withConfig({
  displayName: "ThreeUpSegment__ImageBox",
  componentId: "cmlk1j-1"
})(["width:100%;padding:0px ", ";@media (max-width:", "){width:60%;align-self:center;}"], spacer16, screenMdMin);
var Headline = withAnimationContext(styled(Type.h1).attrs({
  variant: Type.heading2,
  weight: Type.bold
}).withConfig({
  displayName: "ThreeUpSegment__Headline",
  componentId: "cmlk1j-2"
})(["", ";font-size:", ";padding-top:", ";padding-bottom:", ";@media (max-width:", "){padding-top:", ";}"], fadeInAnimation(DELAYS.THIRD), heading1FontSizeXSmall, spacer16, spacer16, screenMdMin, spacer16));
var SegmentTextLink = styled(ButtonTertiaryAsLink).withConfig({
  displayName: "ThreeUpSegment__SegmentTextLink",
  componentId: "cmlk1j-3"
})(["padding:0px;text-align:center;color:", ";text-decoration:none;&:hover:not(:focus):not(:disabled){color:", ";}svg{padding-left:", ";padding-bottom:", ";vertical-align:middle;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return hexToRgba(theme.box.text, 0.5);
}, spacer8, spacer4);
var BodySection = withAnimationContext(styled(Type.p).attrs({
  variant: Type.body1
}).withConfig({
  displayName: "ThreeUpSegment__BodySection",
  componentId: "cmlk1j-4"
})(["", ";"], fadeInAnimation(DELAYS.FOURTH)));
var TRACK_CAT = 'module-featuredContent3Up';
export var ThreeUpSegment = function ThreeUpSegment(_ref3) {
  var _ref3$threeUpSegment = _ref3.threeUpSegment,
      threeUpSegment = _ref3$threeUpSegment === void 0 ? {} : _ref3$threeUpSegment;
  return /*#__PURE__*/_jsxs(Segment, {
    children: [threeUpSegment.image && /*#__PURE__*/_jsx(ImageBox, {
      children: /*#__PURE__*/_jsx(ContentfulImage, {
        asset: threeUpSegment.image
      })
    }), /*#__PURE__*/_jsx(Headline, {
      children: threeUpSegment.headline
    }), /*#__PURE__*/_jsx(BodySection, {
      children: threeUpSegment.body
    }), threeUpSegment.linkText && threeUpSegment.linkUrl && /*#__PURE__*/_jsxs(SegmentTextLink, {
      href: fixHref(threeUpSegment.linkUrl),
      track: [TRACK_CAT, "Link - ".concat(threeUpSegment.linkText)],
      children: [threeUpSegment.linkText, /*#__PURE__*/_jsx(IconArrowRight, {})]
    })]
  });
};